<div class="lx-drawer__drawer" [class.lx-drawer__drawer--is-active]="active">
  <div class="lx-drawer__drawer-header" (click)="clickToggle()">
    <span>{{ title }}</span>
    <lx-button
      [svg]="'remove'"
      [hasText]="false"
      [svgColor]="'light'"
      [btnRounded]="true"
      [buttonStyle]="'plain-text'"
      (buttonClick)="onClickToggleDrawer($event)"
    >
    </lx-button>
  </div>
  <div class="lx-drawer__drawer-content">
    <ng-content></ng-content>
  </div>
  <div class="lx-drawer__drawer-footer" *ngIf="showDrawerButtons">
    <lx-button [style]="{ marginInlineEnd: '5px' }" [block]="true" [btnRounded]="true" [buttonStyle]="'tertiary'" (buttonClick)="onClickReset()">
      <ng-container i18n>Reset filter</ng-container>
    </lx-button>
    <lx-button [style]="{ marginInlineStart: '5px' }" [block]="true" [btnRounded]="true" [buttonStyle]="'primary'" (buttonClick)="onClickApply()">
      <ng-container i18n>Apply</ng-container>
    </lx-button>
  </div>
</div>
